import React, { FC, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { HomePagePresenter } from './HomePagePresenter'
import { hooks } from '../../../libs'

export const HomePageContainer: FC = () => {
  const history = useHistory()
  const { tenantIds } = hooks.useAuth()
  const { hasTolOperationAccess } = hooks.useTolOperation()

  const hasTenantsAccess = tenantIds && tenantIds.length > 0

  useEffect(() => {
    if (hasTenantsAccess && hasTolOperationAccess) return

    if (hasTenantsAccess && !hasTolOperationAccess) {
      history.replace('/select-account')
      return
    }

    if (!hasTenantsAccess && hasTolOperationAccess) {
      history.replace('/tol-operations')
      return
    }

    history.replace('/unauthorized')
  }, [hasTenantsAccess, hasTolOperationAccess, history])

  if (!hasTenantsAccess || !hasTolOperationAccess) {
    return <></>
  }

  return <HomePagePresenter />
}

export default () => {
  return <HomePageContainer />
}
